<template>
  <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="100">
      <div>
        <FormItem label="分期方案" prop="planId">
          <sl-select v-model="form.planId" :data="plans" @on-change="handleChange" :full-props="true"></sl-select>
        </FormItem>

        <sl-table ref="table" :loading="loading" :columns="columns" :data="goodsInfo" :enable-pager="false"></sl-table>
      </div>
      <Divider dashed />
      <div v-if="visibleCreditInfo">
        <Divider>授信信息</Divider>
        <Row>
          <sl-label :label-width="100" title="企业授信总额度">{{creditInfo.creditAmount}}</sl-label>
        </Row>
        <Row>
          <sl-label :label-width="100" title="可用额度">{{creditInfo.leftAmount}}</sl-label>
        </Row>
        <Row>
          <sl-label :label-width="100" title="授信截至日期">{{creditInfo.expirationDateText}}</sl-label>
        </Row>
      </div>

      <FormItem label="订单金额">
        <InputNumber :value="data.totalAmount" disabled></InputNumber>
      </FormItem>
      
      <FormItem v-if="visibleApply" label="申请授信金额">
          <InputNumber :min="1" :step="1" v-model="form.creditAmount"></InputNumber>
      </FormItem>
      <FormItem v-if="data.buySubject != 0" label="申请贷款金额">
        <InputNumber :min="1" :step="1" v-model="form.loanAmount" :disabled="data.flowState > 5"></InputNumber>
      </FormItem>
      <FormItem>
        <Button @click="reset">重置</Button>
        <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
      </FormItem>
    </Form>
</template>
<script>
export default {
  data() {
    return {
      modalVisible:false,
      rules: {
        loanAmount: [ { type:'number' , message: '必须是数字', trigger: 'blur,change' } ],
        planId: [ { require:true , message: '请选择分期方案', trigger: 'blur,change' } ],
      },
      columns:[
        {title:'商品名', key:'skuName'},
        {title:'方案名称', key:'financeName'},
        {title:'结算周期', key:'clearingTypeText'},
        {title:'分期月数',key:'stagesMonth'},
        {title:'每期还款额', key:'price'},
      ],
      data:{ base:{} },
      form:{
        planId:null,
        creditAmount:null,
        loanAmount:null,
        stagesMonth:null,
        clearingType:null,
      },
      product:{
        companyName:null,
        stagesMonth:null,
        clearingType:null
      },
      creditInfo:{},
      goodsInfo:[],
      plans:[],
      planId:null,
      loading:false
    }
  },

  props:{
    orderId:{

    },

    datas:{
      type:Object,
      default:function(){
        return {}
      }
    }
  },
  watch:{
    orderId(val){
      if(val){
        this.query()
      }
    },
    datas(val){
      if(val && val.orderId){
        this.setData( val )
      }
    }
  },

  computed:{
    visibleCreditInfo:function(){
      return this.creditInfo.creditAmount && this.creditInfo.expirationDateText
    },
    visibleApply:function(){
      return this.data.flowState == 5
    },
    disabled:function(){
      this.data.flowState > 5 && this.data.flowState < 8
    }
  },

  created() {
    
  },

  methods: {
    init(id) {
      //this.form.id = id
    },

    query(){
      this.$request.orderInstallment(this.orderId).then(resp => {
        if(!resp.code){
          this.setData( resp.data || {})
        }else{
          this.$Message.error({content:resp.message})
        }
      })
    },

    setData(data){
      this.data = data

      this.creditInfo = data

      this.$utils.fill(this.product , data)

      this.$utils.fill(this.form , data)

      this.data.stagesMonth = this.data.stagesYear

      this.form.planId = data.stagesMonth + '.' + data.clearingType

      this.$request.skusFinance(data.goods).then(resp=>{
        this.plans = (this.$utils.conv(resp.data || [] , {clearingType:'$clearingType'})).map((i) => ({
          value : i.stagesMonth + '.' + i.clearingType,
          label : i.stagesMonth + '期 ' + i.clearingTypeText,
          raw:i, 
        }))

        if( this.form.planId ){
          this.handleChange({raw:this.data})
        }
      })

      console.log( this.data )
    },

    save() {
      let params = { 
        orderId : this.data.orderId,
        creditAmount:this.form.creditAmount,
        loanAmount:this.form.loanAmount,
        stagesMonth:this.form.stagesMonth,
        clearingType:this.form.clearingType,
      }

      this.loading = true
      this.$request.orderFinanceUpdate(params).then(resp => {
        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('操作成功')
          this.$emit('on-update')
          this.modalVisible = false
          // this.$keepAlive.update()
        }
        this.loading = false
      })

    },
    reset(){
      this.$utils.fill(this.form , this.data)
      this.data = this.def
    },

    handleCreate(){
      let params = { orderId: this.data.orderId }
      this.$request.orderFinanceIntersection(params).then(resp=>{
        console.log(resp)
      })
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    },

    handleChange(d){
      if(d && d.raw){
        const raw = d.raw
        let opts = {
          orderId:this.data.orderId , 
          clearingType:raw.clearingType,
          stagesMonth:raw.stagesMonth,
        }
        this.form.clearingType = raw.clearingType
        this.form.stagesMonth = raw.stagesMonth

        this.$request.skuFinanceDetail(opts).then(resp=>{
          this.goodsInfo = this.$utils.conv(resp.data || [] , {'clearingType':'$clearingType'})
        })
      }else{
        this.goodsInfo = []
      }
      
    }
  }
}
</script>